import get from 'lodash.get';
import { numberWithCommas } from '@/utilities';
import BaseAuction from './BaseAuction';

export default class SavedAuction extends BaseAuction {
  constructor(auction, dealerships) {
    super(auction);
    // TODO: Re-factor this. Either update the API to include this info or move it to the Vue. -ETC
    this.dealerships = dealerships;
    this.auction.type = 'saved';
  }

  get imageThumbnail() {
    return get(this.auction, 'images[0].thumbnail', '');
  }

  get statusDisplay() {
    return get(this.auction, 'status.display', '');
  }

  get sellerDealerId() {
    return get(this.auction, 'dealer_id', 0);
  }

  get sellerDealership() {
    return get(this.dealerships, this.auction.dealer_id, { name: 'Unknown' });
  }

  // For saved auctions, the viewing user is always the seller
  // (users can only see their own saved auctions)
  // eslint-disable-next-line class-methods-use-this
  get isMemberOfSellingDealership() {
    return true;
  }

  get updatedTimestamp() {
    return get(this.auction, 'updated_timestamp'); // TODO dayjs
  }

  get savedAuctionId() {
    return get(this.auction, 'id');
  }

  get laneOptions() {
    return get(this.auction, 'lane_options');
  }

  get launchCount() {
    return get(this.auction, 'launch_count', 0);
  }

  get runNumber() {
    return this.launchCount + 1;
  }

  get previousReserve() {
    return get(this.auction, 'previous_reserve');
  }

  get previousStartTime() {
    return get(this.auction, 'previous_start_time');
  }

  get previousBidCount() {
    return get(this.auction, 'previous_bid_count');
  }

  get previousViewCount() {
    return get(this.auction, 'previous_view_count');
  }

  get previousLaunchAddressId() {
    return this.auction.previous_launch_address_id;
  }

  get displayInfo() {
    return [
      {
        name: 'VIN',
        value: this.vin,
      },
      {
        name: 'Odometer',
        value: numberWithCommas(this.odometer),
      },
      {
        name: 'Transmission',
        value: this.transmission,
      },
      {
        name: 'Trim',
        value: this.trim,
      },
      {
        name: 'Drivetrain',
        value: this.drivetrain,
      },
    ];
  }

  get odometer() {
    return get(this.auction, 'odometer');
  }

  get transmission() {
    return get(this.auction, 'transmission');
  }

  get trim() {
    return get(this.auction, 'trim');
  }

  get drivetrain() {
    return get(this.auction, 'drivetrain');
  }

  get savedOnlineText() {
    const updated = new Date(this.auction.updated_timestamp * 1000);
    const months = `0${updated.getMonth() + 1}`;
    const date = `0${updated.getDate()}`;
    let hours = updated.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = `0${hours > 12 ? hours - 12 : hours}`;
    const minutes = `0${updated.getMinutes()}`;
    return `Saved Online: ${(months).slice(-2)}/${
      (date).slice(-2)} - ${
      (hours).slice(-2)}:${
      (minutes).slice(-2)
    }${ampm}`;
  }

  // eslint-disable-next-line class-methods-use-this
  lastBidWasUsers() {
    return false;
  }

  get actionText() {
    let actionText;

    switch (this.status) {
      case 'complete':
        actionText = 'Send To Auction';
        // clonedAuction.auction_action = 10;
        // clonedAuction.auction_state_button_actionable = true;
        break;

      case 'submitted':
        actionText = 'Auction Launched!';
        break;

      case 'max_launches':
        actionText = 'No More Launches';
        break;

      case 'expired':
        actionText = 'Expired';
        break;

      default:
        actionText = 'Missing Info';
        break;
    }

    return actionText;
  }

  get hasLaunched() {
    return get(this.auction, 'launch_count', 0) > 0;
  }

  isSavedAuction() {
    return get(this.auction, 'type') === 'saved';
  }

  get isReadOnly() {
    return get(this.auction, 'read_only', false);
  }

  getSellerDealershipName() {
    return this.sellerDealership.name;
  }

  get sellerDealershipAutosellLaunchOnly() {
    return get(this.auction, 'seller.dealer.autosell_launch_only', false);
  }

  get sellerGoGreenProgram() {
    return get(this.auction, 'seller.go_green', false);
  }

  get startPrice() {
    return get(this.auction, 'previous_start_price');
  }

  get startTime() {
    return get(this.auction, 'previous_start_time');
  }

  get privateLanes() {
    return get(this.auction, 'private_lanes', []);
  }

  get eventLanes() {
    return get(this.auction, 'event_lanes', []);
  }

  get privateStatusValue() {
    return get(this.auction, 'private_status.value') || get(this.auction, 'private_status');
  }

  get noReservePreviewLaneLaunchWindows() {
    return get(this.auction, 'no_reserve_preview_lane_launch_windows', []);
  }

  get liveAppraisalDescription() {
    return get(this.auction, 'live_appraisal_description', null);
  }

  get forceRedLight() {
    return get(this.auction, 'force_red_light', null);
  }

  get forceRedLightMessage() {
    return get(this.auction, 'force_red_light_message', null);
  }

  get forceRedLightMessages() {
    return get(this.auction, 'force_red_light_messages', []) || [];
  }
}
